"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSpring = require("react-spring");
var _react2 = require("@use-gesture/react");
var _Logo = _interopRequireDefault(require("../Logo"));
var _Button = _interopRequireDefault(require("../../../Button/Button"));
var _constants = require("../../../constants");
var _User = _interopRequireDefault(require("../User"));
var _ContactButton = _interopRequireDefault(require("../../../ContactUs/ContactButton"));
var _ComponentWrapper = _interopRequireDefault(require("../../../helpers/ComponentWrapper"));
var _Content = _interopRequireDefault(require("./templates/Content"));
var _BookingFunnel = _interopRequireDefault(require("./templates/BookingFunnel"));
var _envConstants = require("../../../../env-constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var templates = {
  Content: _Content["default"],
  BookingFunnel: _BookingFunnel["default"]
};
var MobileMenu = function MobileMenu(props) {
  var Template = templates[props.template];
  var escFunction = function escFunction(event) {
    if (event.keyCode === 27) {
      close();
    }
  };
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    externalModalToggle = _useState2[0],
    setExternalModalToggle = _useState2[1];
  // this is used as a reference if it is dragging or not
  var draggingRef = (0, _react.useRef)(false);
  var _useSpring = (0, _reactSpring.useSpring)(function () {
      return {
        y: -100,
        overlayOpacity: 0
      };
    }),
    _useSpring2 = (0, _slicedToArray2["default"])(_useSpring, 2),
    _useSpring2$ = _useSpring2[0],
    y = _useSpring2$.y,
    overlayOpacity = _useSpring2$.overlayOpacity,
    set = _useSpring2[1];
  (0, _react.useEffect)(function () {
    // this effect gets fired only when on changes
    if (props.on) {
      // when the user opens the menu, we disable the body from scrolling
      document.body.style.overflow = 'hidden';
      // and add functionality for escape button
      document.addEventListener('keydown', escFunction);
      open(false);
    }
    return function () {
      // clean up after unmounts
      document.body.style.overflow = 'unset';
      document.removeEventListener('keydown', escFunction);
    };
  }, [props.on]);
  var open = function open(_ref) {
    var canceled = _ref.canceled;
    // when cancel is true, it means that the user passed the downwards threshold
    // so we change the spring config to create a nice wobbly effect
    // we clean up onRest function otherwise it will remember to do toggle from close()
    set({
      y: 0,
      overlayOpacity: 1,
      config: canceled ? _reactSpring.config.wobbly : _reactSpring.config.stiff,
      onRest: null
    });
  };
  var close = function close() {
    var velocity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    // taking in account velocity as well how fast you swipe
    // onRest will get fired when animation is finished - toggle() to remove component
    set({
      y: -100,
      overlayOpacity: 0,
      config: _objectSpread(_objectSpread({}, _reactSpring.config.stiff), {}, {
        tension: 310,
        friction: 30,
        velocity: -1 * velocity
      }),
      onRest: function onRest() {
        return props.on && props.toggle();
      }
    });
  };

  // const display = y.to(py => (py > -100 ? 'block' : 'none'));

  var bind = (0, _react2.useDrag)(function (_ref2) {
    var first = _ref2.first,
      last = _ref2.last,
      _ref2$movement = (0, _slicedToArray2["default"])(_ref2.movement, 2),
      mx = _ref2$movement[0],
      my = _ref2$movement[1],
      cancel = _ref2.cancel,
      canceled = _ref2.canceled,
      _ref2$memo = _ref2.memo,
      memo = _ref2$memo === void 0 ? y.getValue() : _ref2$memo,
      _ref2$vxvy = (0, _slicedToArray2["default"])(_ref2.vxvy, 2),
      vx = _ref2$vxvy[0],
      vy = _ref2$vxvy[1];
    if (externalModalToggle) return null;
    var newY = memo + my;

    // if this is not the first or last frame, it's a moving frame
    // then it means the user is dragging
    if (first) draggingRef.current = true;else if (last) draggingRef.current = false;

    // adds friction when dragging downward
    // the more the user down up, the more friction
    if (newY > 0) newY /= 1 - newY * 0.002;

    // if the user drags down passed a threshold, then we cancel
    // the drag so that the menu resets to its open position
    if (newY > 400) cancel();

    // when the user releases, we check whether it passed
    // the treshold for it to close, or if we reset it to its open position
    // or if it has been cancelled so it won't take into consideration velocity when dragging down
    var releaseAction = function releaseAction() {
      return newY < -400 || vy > 0.5 && !canceled ? close(vy) : open({
        canceled: canceled
      });
    };
    if (last) releaseAction();

    // this is just actual dragging
    else set({
      y: my / 10,
      overlayOpacity: 1,
      config: _reactSpring.config.stiff
    });
    return memo;
  });
  return props.on && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactSpring.a.div, {
    className: "mobile--overlay",
    style: {
      opacity: overlayOpacity
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactSpring.a.div, {
    // {...bind()}
    className: "mobile--menu d8-u-overflow-y-scroll",
    style: {
      top: y.to(function (topY) {
        return "".concat(topY, "%");
      })
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mobile--menu__top flex items-center justify-between bg-white"
  }, /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
    className: "flex items-center justify-between padding-top-xxs padding-bottom-xxs"
  }, /*#__PURE__*/_react["default"].createElement(_Logo["default"], {
    config: props.logo,
    on: props.on,
    iconClassName: "icon--xl"
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-right-lg inline-flex"
  }, /*#__PURE__*/_react["default"].createElement(_ContactButton["default"], {
    mobile: true,
    text: "Call us",
    brand: _envConstants.ENV.SITE
  })), _envConstants.ENV.SITE === 'ynf' ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-right-lg inline-flex"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "margin-right-xxxs flex",
    style: {
      flexDirection: 'column'
    },
    target: "_blank",
    href: "https://www.theyachtweek.com/account/login?brand=ynf"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    icon: "person",
    buttonType: _constants.BUTTON_TYPES.BARE_NO_PADDING,
    className: "user-placeholder",
    buttonSize: _constants.BUTTON_SIZES.XXXLARGE
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-xs d8-u-color-contrast-high d8-u-text-semi-bold"
  }, "Login"))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-right-lg inline-flex"
  }, /*#__PURE__*/_react["default"].createElement(_User["default"], {
    mobile: true,
    user: props.user,
    on: props.on
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex flex-column flex-center"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    icon: "cross",
    buttonType: _constants.BUTTON_TYPES.BARE_NO_PADDING,
    onClick: function onClick() {
      return !draggingRef.current && close();
    },
    buttonSize: _constants.BUTTON_SIZES.XXXLARGE
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-xs d8-u-color-contrast-high d8-u-text-semi-bold"
  }, "Close"))))), /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement(Template, props))));
};
MobileMenu.propTypes = {
  logo: _propTypes["default"].object,
  links: _propTypes["default"].arrayOf(_propTypes["default"].object),
  user: _propTypes["default"].object,
  on: _propTypes["default"].bool,
  toggle: _propTypes["default"].func,
  template: _propTypes["default"].string
};
MobileMenu.defaultProps = {
  template: 'Content'
};
var _default = exports["default"] = MobileMenu;